import { ReactElement } from 'react';

import { VisitHistoryQuery } from '@dreryk/egabinet-visit-frontend-api';
import {
   ConfidentialResourceAccessRequestCreateCommand,
   ConfidentialResourceAccessSelfGrantCommand,
} from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { PromiseVoidFunction } from '@dreryk/react-common';
import { dispatchSnackbarPositiveEvent, Link } from '@dreryk/react-components';

import { useCurrentPractitionerGlobalState } from '~libs.shared.account';

import { historicalVisitsTranslationKeys } from '../translations';

type VisitHistoryConfidentialAccessLinkProps = {
   readonly visitId: number;
};

export const VisitHistoryConfidentialAccessLink = (
   props: VisitHistoryConfidentialAccessLinkProps
): ReactElement | null => {
   const { getCurrentPractitioner } = useCurrentPractitionerGlobalState();
   const confidentialAccessLevel = getCurrentPractitioner()?.confidentialAccessLevel;

   const { executeAsync: requestAccess } = useCqrsCommand<void, void>(
      () => {
         const confidentialAccessLevel = getCurrentPractitioner()?.confidentialAccessLevel;
         const Command =
            confidentialAccessLevel === 'MONITORED'
               ? ConfidentialResourceAccessSelfGrantCommand
               : ConfidentialResourceAccessRequestCreateCommand;
         const command = new Command();
         command.resourceId = props.visitId;
         command.resourceType = 'VISIT';
         return command;
      },
      {
         onSuccess: () => {
            const confidentialAccessLevel = getCurrentPractitioner()?.confidentialAccessLevel;
            const snackbarMessage =
               confidentialAccessLevel === 'MONITORED'
                  ? historicalVisitsTranslationKeys.confidentialAccess.selfGrantSuccess
                  : historicalVisitsTranslationKeys.confidentialAccess.requestSuccess;

            dispatchSnackbarPositiveEvent(snackbarMessage);
            refetchCqrsQuery(VisitHistoryQuery);
         },
      }
   );

   const handleClick: PromiseVoidFunction = async () => {
      await requestAccess();
   };

   if (!confidentialAccessLevel) {
      return null;
   }

   return (
      <Link
         testId={'confidentialAccessRequest'}
         label={historicalVisitsTranslationKeys.confidentialAccess.request}
         onClick={handleClick}
      />
   );
};
